import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ArrowLeftIcon, CopyIcon, CheckIcon, UsersIcon } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
export function ThankYouReferralPage() {
  const {
    t,
    getPath,
    navigate
  } = useLanguage();
  const [copied, setCopied] = useState(false);
  const [referralLink, setReferralLink] = useState('');
  return <div className="min-h-screen w-full flex flex-col" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-877">
      <Navigation data-id="element-878" />

      <section className="flex-1 flex items-center justify-center px-4 py-32" data-id="element-879">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-lg" data-id="element-880">
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="w-24 h-24 mx-auto mb-8 rounded-full flex items-center justify-center" style={{
          backgroundColor: 'var(--accent)'
        }} data-id="element-881">
            <UsersIcon className="w-12 h-12 text-white" data-id="element-882" />
          </motion.div>

          <h1 className="text-3xl sm:text-4xl font-bold mb-4" style={{
          color: 'var(--text-primary)'
        }} data-id="element-883">
            {t('thankyou.ref.title')}
          </h1>

          <p className="text-lg mb-4" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-884">
            {t('thankyou.ref.desc')}
          </p>

          <p className="text-base mb-8" style={{
          color: 'var(--text-muted)'
        }} data-id="element-885">
            {t('thankyou.ref.note')}
          </p>

          <div className="rounded-2xl border p-6 mb-8 text-left" style={{
          borderColor: 'var(--border)',
          backgroundColor: 'var(--bg-secondary)'
        }} data-id="element-886">
            <h3 className="font-semibold mb-3" style={{
            color: 'var(--text-primary)'
          }} data-id="element-887">
              {t('thankyou.ref.next')}
            </h3>
            <ul className="space-y-2 text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-888">
              <li className="flex items-start gap-2" data-id="element-889">
                <span style={{
                color: 'var(--accent)'
              }} data-id="element-890">
                  1.
                </span>
                {t('thankyou.ref.step1')}
              </li>
              <li className="flex items-start gap-2" data-id="element-891">
                <span style={{
                color: 'var(--accent)'
              }} data-id="element-892">
                  2.
                </span>
                {t('thankyou.ref.step2')}
              </li>
              <li className="flex items-start gap-2" data-id="element-893">
                <span style={{
                color: 'var(--accent)'
              }} data-id="element-894">
                  3.
                </span>
                {t('thankyou.ref.step3')}
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-895">
            <a href={getPath('')} onClick={e => {
            e.preventDefault();
            navigate('');
          }} className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm font-semibold transition-all hover:scale-105" style={{
            backgroundColor: 'var(--bg-secondary)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border)'
          }} data-id="element-896">
              <ArrowLeftIcon className="w-4 h-4" data-id="element-897" />
              {t('nav.home')}
            </a>
          </div>
        </motion.div>
      </section>

      <Footer data-id="element-898" />
    </div>;
}